import { AccessType } from './environmentModels';

const VP_PROXY_NO_TLD = 'vistaprint';

/**
 * Function that checks current browser hostname and maps it to an access type:
 *  - Proxy - represents `www.vistaprint.*`, `next.vistaprint.*`, `staging.vistparint.*`
 *  - Direct - represents `vpsvc.com` or `localhost`
 *  - None - either SSR or error state
 * @returns AccessType: (Proxy, Direct, None)
 */
export default function getAccessType(): AccessType {
  if (typeof window !== 'undefined') {
    const hostname = window.location?.hostname ?? '';

    if (hostname.includes(VP_PROXY_NO_TLD)) {
      return AccessType.Proxy;
    } else if (hostname.match(/vpsvc.com|localhost/)) {
      return AccessType.Direct;
    }
  }
  return AccessType.None;
}
